// dependencies
import { mount } from 'svelte';
import App from './App.svelte';

// polyfills
import './utils/polyfills';

// styles
import './styles/graphic.scss';

// Clear console in development
if (import.meta.env.DEV) {
  console.clear();
}

// Optionally show/hide the headline + dek via a query param.
// e.g. ?meta=false (or hide/0) hides them; ?meta=true (or show/1) forces them on.
// Absent -> default (visible). Useful for home-page/card embeds.
// NB: this graphic's #meta block also holds the chart's data-label and legend,
// so we target the headline + dek specifically rather than all of #meta.
(() => {
  const value = new URLSearchParams(window.location.search).get('meta');
  if (value === null) return;

  const hide = ['false', '0', 'hide', 'no'].includes(value.toLowerCase());
  document
    .querySelectorAll('#meta .headline, #meta .dek')
    .forEach((el) => { el.style.display = hide ? 'none' : ''; });
})();

// Mount the app using Svelte 5 API
const app = mount(App, {
  target: document.getElementById('graphic'),
});

export default app;
